module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENGLAND 1878")])]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-No-Indent-potx1"
  }, [_c('span', {
    staticClass: "Script"
  }, [_vm._v("Sometimes, ")]), _vm._v("in this big, cold house, I pretend I am an explorer on an expedition, navigating the long corridors like rivers, the huge rooms like undiscovered islands. I crawl under tables and leap onto sofas. I take my sister’s hand, and we run through the rooms together. But the air next to my body is cold because she isn’t really there, and when I look at the empty space next to me, my chest hurts. It hurts right where my heart is, so I think that this must be what is meant by a broken heart.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why,” I ask Maman, “is everything different?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She puts her hands on my cheeks and looks at me with eyes that are so soft and brown I wish I could touch them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You are just a boy,” she says. “It is too much for a boy to understand.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef8734c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0